import React from 'react';

import PropTypes from 'prop-types';
import { StyledTypography } from 'styles/common';

import { getColorFromGoalProgressLevel, getGoalProgress } from 'services/helpers/goal';

export default function GoalProgressText({
  defaultDisplayValue,
  startValue,
  achievedValue,
  targetValue,
  className,
  progressLevel,
}) {
  const progressText = getGoalProgress({
    defaultDisplayValue,
    startValue,
    achievedValue,
    targetValue,
  });
  const color = getColorFromGoalProgressLevel(progressLevel) || 'textSecondary';
  return (
    <StyledTypography className={className} variant="caption" display="inline" color={color} weight="bold">
      {progressText} %
    </StyledTypography>
  );
}

GoalProgressText.propTypes = {
  progressText: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};
